module.exports = function() {
  return new Worker(__webpack_public_path__ + "7a6bfa5c26c8f58d8884.worker.js");
};